import { getProgramData } from '~shared/api/single-program-data/single-program-data'
import { blendWithWhite } from '~shared/utils/blendWithWhite'

const DOCUMENTS = ['Паспорт', 'Диплом / аттестат', 'Заявление на поступление']

// ─── IconCheck ────────────────────────────────────────────────────────────────

const IconCheck = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20 6L9 17L4 12'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

// ─── Component ────────────────────────────────────────────────────────────────

export const LeastDocumentsSection = ({
  program
}: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const color = program?.faculty?.color ?? '#3A52EE'

  return (
    <section
      className='py-[56px] 2lg:py-[80px]'
      style={{ backgroundColor: color }}>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <div className='flex flex-col 2lg:flex-row items-center gap-[40px] 2lg:gap-[32px] text-white'>
          {/* Left: title */}
          <div className='2lg:flex-[2]'>
            <h2 className='text-[32px] md:text-[40px] 2lg:text-[64px] font-medium leading-[120%] '>
              Для поступления потребуется минимум документов
            </h2>
          </div>

          {/* Right: documents list */}
          <div className='2lg:flex-[1] w-full flex flex-col gap-[32px]'>
            {DOCUMENTS.map((document, idx) => (
              <div
                key={`LeastDocument__${document}-${idx + 1}`}
                className='flex items-center'>
                <div
                  className='shrink-0 w-[41px] h-[41px] rounded-[4px] flex items-center justify-center mr-[16px]'
                  style={{ backgroundColor: blendWithWhite(color, 0.85) }}>
                  <IconCheck />
                </div>
                <p className='text-[16px] 2lg:text-[18px] leading-[140%]'>
                  {document}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
